import React, { FC } from 'react';

import { styled } from '@mui/material';
import Typography from '@mui/material/Typography';

import ClockIcon from '~/assets/icons/ClockIcon';
import useTenantTranslation from '~/hooks/useTenantTranslation';

interface ComingSoonOverlayProps {
  withChildren?: boolean;
}

export const ComingSoonOverlay: FC<ComingSoonOverlayProps> = ({ withChildren = true }) => {
  const { t } = useTenantTranslation();

  return (
    <Wrapper>
      {withChildren && (
        <>
          <ClockIcon secondaryColor={'white'} color={'white'} boldHand={false} />
          <Text>{t('page.discover.comingSoon')}</Text>
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background: rgba(34, 34, 34, 0.5);
  pointer-events: none;
  backdrop-filter: blur(1px) grayscale(1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  svg {
    width: 52px;
    margin-bottom: 14px;
  }
`;

const Text = styled(Typography)`
  font-size: 16px;
  font-weight: 700;
  color: white;
  line-height: 19px;
`;
